import React from "react";

const WhatsappIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <path
        d="M12.5666 0.00703593C5.87722 0.22385 0.351398 5.64202 0.0169289 12.3273C-0.104003 14.7373 0.427661 17.0155 1.46157 18.993L0.00930258 25.4974C-0.0517078 25.7916 0.208677 26.052 0.502835 25.9909L7.007 24.5386L7.01136 24.5386C8.97569 25.5649 11.2298 26.0966 13.6223 25.9855C20.2964 25.6761 25.7318 20.1925 25.99 13.516C26.282 5.95471 20.1188 -0.238101 12.5666 0.00703593ZM13.0002 23.3107C11.1089 23.3107 9.33739 22.7997 7.81431 21.9074C7.67049 21.8268 7.53213 21.7418 7.39704 21.6514L3.24178 22.7583L4.34868 18.6029C3.29952 16.9893 2.6905 15.0663 2.6905 12.9995C2.6905 7.31552 7.31642 2.68942 13.0002 2.68942C18.684 2.68942 23.3099 7.31552 23.3099 12.9995C23.3099 18.6835 18.684 23.3096 13.0002 23.3096L13.0002 23.3107Z"
        fillRule="nonzero"
        transform="matrix(1 0 0 1 0 0)"
        fill="rgb(255, 255, 255)"
      />
      <path
        d="M12.389 10.8146C12.2093 11.0848 12.0208 11.3364 11.719 11.6372C11.0588 12.2974 10.1415 12.6308 9.21105 12.536C7.54415 12.365 5.17563 11.4443 3.1394 9.41236C1.10317 7.37605 0.182567 5.00744 0.0158777 3.34048C-0.0789062 2.41003 0.254473 1.49375 0.914695 0.832411C1.21539 0.531705 1.46706 0.342128 1.73725 0.158C2.23623 -0.178661 2.91497 0.0457795 3.10345 0.612328L3.78655 2.66171C3.97503 3.2239 3.89005 3.57908 3.6471 3.8166L3.10345 4.36572C2.83326 4.63592 2.78859 5.0532 2.99559 5.37679C3.29629 5.84855 3.86282 6.60358 4.90544 7.64625C5.94807 8.68892 6.70308 9.25547 7.17482 9.55618C7.49839 9.76319 7.91675 9.71852 8.18585 9.44832L8.73495 8.90464C8.97354 8.66168 9.32871 8.5767 9.88979 8.76519L11.9391 9.44832C12.5056 9.6368 12.7301 10.3156 12.389 10.8146Z"
        fillRule="nonzero"
        transform="matrix(1 0 0 1 6.72547 6.72395)"
        fill="rgb(255, 255, 255)"
      />
    </svg>
  );
};

export default WhatsappIcon;
